const APICodes = {
    SIGN_UP: 1,
    SIGN_IN: 2,
    SOCIAL_SIGN_IN: 3,
    WRITE_REVIEW: 4,
    RESET_PASSWORD: 5,
    RECOMMEND_COURSE: 6,
    COMMON_DATA: 7,
    EDIT_PROFILE_DATA: 8,
    UPDATE_LEARNER: 9,
    UPDATE_LEARNING_ENABLER: 10,
    SEND_FEEDBACK: 11,
    CHANGE_PASSWORD: 12,
    CREATE_VIDEO: 13,
    VERIFY_EMAIL: 14,
    PROGRAM_ENROLL: 15,
    UPDATE_REQUESTED_USER_DATA: 16,
    LOG_OUT: 17
}

Object.freeze(APICodes);

export { APICodes };